import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    testUrl: String,
    testButtonText: String,
    testingButtonText: String
  }

  static targets = ["result", "testButton"]

  async testEndpoint(event) {
    event.preventDefault()

    if (!this.hasTestUrlValue) return

    this.setTestingState(true)
    this.renderInfo()

    try {
      const formData = new FormData(this.element)
      formData.delete("_method")
      formData.delete("commit")

      const response = await fetch(this.testUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-TOKEN": window.compliance.token,
          "Accept": "application/json"
        },
        body: formData
      })

      const data = await response.json()
      this.renderResult(data, response.ok)
    } catch (_error) {
      this.renderResult(
        {
          message: "No fue posible probar el endpoint. Revisa tu conexión e inténtalo nuevamente.",
          details: []
        },
        false
      )
    } finally {
      this.setTestingState(false)
    }
  }

  setTestingState(isTesting) {
    if (!this.hasTestButtonTarget) return

    this.testButtonTarget.disabled = isTesting
    this.testButtonTarget.textContent = isTesting
      ? (this.hasTestingButtonTextValue ? this.testingButtonTextValue : "Probando...")
      : (this.hasTestButtonTextValue ? this.testButtonTextValue : "Probar endpoint")
  }

  renderInfo() {
    if (!this.hasResultTarget) return

    this.resultTarget.innerHTML = `
      <div class="alert alert-info" role="alert">
        Probando endpoint...
      </div>
    `
  }

  renderResult(data, isSuccess) {
    if (!this.hasResultTarget) return

    const alertClass = isSuccess ? "alert-success" : "alert-danger"
    const message = data?.message || (isSuccess ? "Prueba completada" : "La prueba falló")
    const details = Array.isArray(data?.details) ? data.details : []

    const detailsHtml = details.length > 0
      ? `<ul class="mb-0">${details.map((detail) => `<li>${this.escapeHtml(String(detail))}</li>`).join("")}</ul>`
      : ""

    this.resultTarget.innerHTML = `
      <div class="alert ${alertClass}" role="alert">
        <p class="mb-1">${this.escapeHtml(message)}</p>
        ${detailsHtml}
      </div>
    `
  }

  escapeHtml(value) {
    return value
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;")
  }
}
